<template>
  <div class="row">
    <h3 class="mb-2">Change Password</h3>
    <hr>
    <div :class="message.alert" class="alert" v-if="message.text" role="alert">
      {{ message.text }}
    </div>
    <div class="form-group row m-b-15">
      <label for="password-input" class="col-lg-3 col-form-label">Password</label>
      <div class="col-lg-7">
        <input class="form-control" :class="{'is-invalid': $v.password.$error}" type="password" v-model.trim="password" id="password-input" @input="$v.password.$touch()">
        <div v-if="$v.password.$error" :class="{'invalid-feedback': !$v.password.minLength}">Password min length is 6</div>
      </div>
    </div>

    <div class="form-group row m-b-15">
      <label for="confirm-password-input" class="col-lg-3 col-form-label">Confirm password</label>
      <div class="col-lg-7">
        <input class="form-control" :class="{'is-invalid': $v.confirmPassword.$error}" type="password" v-model.trim="confirmPassword" id="confirm-password-input" @input="$v.confirmPassword.$touch()">
        <div v-if="$v.confirmPassword.$error" :class="{'invalid-feedback': !$v.confirmPassword.sameAsPassword}">Passwords must be identical.</div>
      </div>
    </div>
    <hr>
    <div class="form-group text-center">
      <button type="submit" class="btn btn-primary" v-on:click.stop.prevent="save()">Change password</button>
      <router-link role="button" type="cancel" class="btn btn-white" :to="{ name: 'Profile'}">Cancel</router-link>
    </div>
  </div>
</template>

<script>
import { validationMixin } from 'vuelidate'
import { required, minLength, sameAs } from 'vuelidate/lib/validators'

export default {
  name: 'EditProfile',
  mixins: [validationMixin],
  validations: {
    password: {
      required,
      minLength: minLength(6)
    },
    confirmPassword: {
      sameAsPassword: sameAs('password')
    }
  },
  data() {
    return {
      password: null,
      confirmPassword: null,
      message: {}
    }
  },
  methods: {
    hideMessage() {
      this.message = {}
    },
    showMessage(message) {
      this.message = message
    },
    save: function() {
      this.hideMessage()
      if (!this.$v.confirmPassword.$invalid && !this.$v.password.$invalid) {
        this.$http
          .post('user/me/reset-password', { password: this.password })
          .then(
            response => {
              this.showMessage({ text: 'Your password has been changed successfully', alert: 'alert-info' })
            },
            err => {
              // error callback
              console.log(err)
              this.showMessage({ text: 'Sorry, your password was not changed, please try again', alert: 'alert-danger' })
            }
          )
      } else {
        this.showMessage({ text: 'Password is required and must be at least 6 characters long', alert: 'alert-danger' })
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/profile/EditPasswordProfile.vue